"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackFullTextSearchResult = exports.trackSRLResult = void 0;
const libs_tracking_events_1 = require("@hotelplan/libs.tracking-events");
const trackSearch_1 = require("./trackSearch");
const trackSRLResult = (data, searchData) => {
    (0, libs_tracking_events_1.track)({
        event: '🚀 srl.results',
        eventMetadata: data,
        search: (0, trackSearch_1.mapSearchControlDataToTrackableData)(searchData),
        _clear: true,
    });
};
exports.trackSRLResult = trackSRLResult;
function trackFullTextSearchResult(data) {
    (0, libs_tracking_events_1.track)({
        event: '🚀 srl.results',
        eventMetaData: data,
        _clear: true,
    });
}
exports.trackFullTextSearchResult = trackFullTextSearchResult;
//# sourceMappingURL=trackSRLResult.js.map